import React from "react";
import styled from "styled-components";
import { Form, Input, Row, DatePicker, Tooltip, InputNumber } from "antd";
import moment from "moment";
import fontStyle from "src/styles/fontStyle";
import { Product } from "@api/throughShipment/onlineOrderApi";
import { InfoCircleTwoTone } from "@ant-design/icons";

const Notice = styled.span`
  margin-top: 5px;
  margin-left: 10px;
  color: ${({ theme }) => theme.colorNeutral500};
  ${fontStyle("14px", "22px")};
`;

const CustomDatePicker = styled(DatePicker)`
  width: 230px;
`;

const InfoIcon = styled(InfoCircleTwoTone)`
  margin-left: 4px;
`;

type Props = {
  currentProduct?: Product;
  availableQty: number;
  isB2B: boolean;
};

export default function TcatWarehouseFields({ currentProduct, availableQty, isB2B }: Props) {
  return (
    <>
      <Row>
        <Form.Item label="庫存量" name="stock" labelAlign="left">
          <Input disabled />
        </Form.Item>
        <Notice>*輸入品號後自動帶入</Notice>
      </Row>

      <Form.Item label="商品效期" name="effectiveDate" labelAlign="left">
        <CustomDatePicker
          allowClear
          defaultValue={currentProduct?.effectiveDate ? moment(currentProduct.effectiveDate) : undefined}
        />
      </Form.Item>

      <Form.Item
        label="商品數量(pcs)"
        name="estimatedQty"
        labelAlign="left"
        rules={[
          { required: true, message: "" },
          {
            validator: (_, value) => {
              if (value > availableQty) {
                return Promise.reject(new Error("商品數量超過庫存量，請修正"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input type="number" />
      </Form.Item>
      <Form.Item
        label={
          <span>
            單品總金額
            <Tooltip placement="bottom" title="此金額需要為整數，且單品總金額加總要等於訂單總金額。">
              <InfoIcon style={{ transform: "scale(0.9)" }} />
            </Tooltip>
          </span>
        }
        name="unitPrice"
        labelAlign="left"
        rules={[{ required: !isB2B, message: "" }]}
      >
        {isB2B ? (
          "-"
        ) : (
          <InputNumber
            style={{ width: "230px" }}
            min={1}
            precision={0}
            onKeyPress={(event) => {
              // 只允許數字 (0-9)，禁止點號 (.) 或其他字元
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        )}
      </Form.Item>
    </>
  );
}
